import { fetchDefault } from 'src/fetch/common';
import { submitDocDataSet } from './dataSet';

/**
 * Fetch: 제출서류 목록
 */
export const submitDocListDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/submit-doc/lst';
  const fetchKey = 'SUBMIT_DOC_LIST';

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    console.log('[SUBMIT_DOC_LIST]:', paramSet, data);
    const { resError, resData } = submitDocDataSet(data, null);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};
